export enum ProvisioningStatus {
	// The provisioning request has been received, but the environment is not yet being created.
	New = 'New',
	// The provisioning request has started for this environment.
	Creating = 'Creating',
	// The environment has been provisioned successfully.
	Active = 'Active',
	// Creating the environment has failed. See the error code for details.
	CreateFailed = 'CreateFailed',
	// Another status for the error state.
	Error = 'Error',
	// The environment marked for soft delete
	SoftDeleting = 'SoftDeleting',
	// The provisioned resource has been deleted
	Deleted = 'Deleted',
	Deleting = 'Deleting',
	DeleteFailed = 'DeleteFailed',
}
